module.exports = __webpack_public_path__ + "static/media/lukeocean.164a2f81.jpg";